module.exports = __webpack_public_path__ + "static/media/posicionador-01.97e571c9.png";